import { render, staticRenderFns } from "./PercentageBar.vue?vue&type=template&id=722a365a"
import script from "./PercentageBar.vue?vue&type=script&lang=js"
export * from "./PercentageBar.vue?vue&type=script&lang=js"
import style0 from "./PercentageBar.vue?vue&type=style&index=0&id=722a365a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports